<template>
  <div class="query">
    <div class="query__title">商务微信</div>
    <div class="query__content">
      <el-card class="query__text">
        <img src="/images/wx.png"/>
      </el-card>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        value: '',
        baseList: [],
        page: {
          currentPage: 1,
          total: 0,
          pageSize: 10
        }
      }
    },
    created() {
    },
    methods: {
    }
  };
</script>

<style lang="scss">
  .query {
    padding-top: 150px;
    min-height: 500px;
    height: auto;

    &__title {
      width: 100%;
      font-size: 42px;
      text-align: center;
      font-weight: 600;
    }

    &__search {
      width: 600px;
      margin: 60px auto 0 auto;
    }

    &__content {
      width: 100%;
      margin: 30px 0;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      justify-content: center;
    }

    &__text {
      box-sizing: border-box;
      margin: 15px 10px 0 10px;
      width: 40%;

      p {
        line-height: 30px;
      }
    }
  }
</style>
